import { IFinancial } from '../../../../data/entities/customer/financial';
import { IAddress } from '../../../components/address';

export enum AddressTypes {
	CORRESPONDENCE,
	REGISTERED
}

export const groupAddresses = (financial: IFinancial): { correspondence: IAddress, registered: IAddress } => {
	return {
		correspondence: {
			address1: financial.correspondence_address1,
			address2: financial.correspondence_address2,
			city: financial.correspondence_city,
			postcode: financial.correspondence_postcode,
			country_code: financial.correspondence_country_code
		},
		registered: {
			address1: financial.business_address1,
			address2: financial.business_address2,
			city: financial.business_city,
			postcode: financial.business_postcode,
			country_code: financial.business_country_code
		}
	};
};

export const addressKeyMap = (addressType: AddressTypes) => {
	switch (addressType) {
		case AddressTypes.REGISTERED:
			return {
				address1: 'business_address1',
				address2: 'business_address2',
				city: 'business_city',
				postcode: 'business_postcode',
				country_code: 'business_country_code'
			};
		case AddressTypes.CORRESPONDENCE:
			return {
				address1: 'correspondence_address1',
				address2: 'correspondence_address2',
				city: 'correspondence_city',
				postcode: 'correspondence_postcode',
				country_code: 'correspondence_country_code'
			};
		default:
			throw new Error('Unsupported address type');
	}
};
